import { lazy } from "react";
import { Navigate } from "react-router";

import DocEdit from "../docgen/components/DocEdit";

const WillsDocGen = lazy(() => import("../docgen/components/WillsDocGen"));
const SocDocGen = lazy(() => import("../docgen/components/soc/SocDocGen"));
const Undertakings = lazy(() => import("./components/Undertakings/UndertakingsDocGen"));
const DefenceUndertakings = lazy(() => import("../docgen/components/DefenceUndertakings"));
const InitialLetters = lazy(() => import("../docgen/components/InitialLetters"));
const BocDocGen = lazy(() => import("../docgen/components/boc/BocDocGen"));
const LegacyBocDocGen = lazy(() => import("../docgen/components/boc-legacy/LegacyBocDocGen"));
const AgreementsTools = lazy(() => import("../docgen/components/agreements/AgreementsTools"));
const AgreementWidget = lazy(() => import("../docgen/components/agreements"));
const TransferLetterGenerator = lazy(() => import("../docgen/components/TransferLetterGenerator"));
const DemandDocGen = lazy(() => import("../docgen/components/Demand/DemandDocGen"));

const docgenRoutes = [
  { index: true, element: <Navigate to={process.env.PUBLIC_URL} /> },
  { path: "will/:projectId", element: <WillsDocGen /> },
  { path: "soc/:projectId/:requestType", element: <SocDocGen /> },
  { path: "undertakings/:projectId/:requestType", element: <Undertakings /> },
  { path: "defence-undertakings/:projectId", element: <DefenceUndertakings /> },
  { path: "initial-letters/:projectId/:letterType", element: <InitialLetters /> },
  { path: "boc/:projectId", element: <BocDocGen /> },
  { path: "legacy-boc/:projectId", element: <LegacyBocDocGen /> },
  { path: "agreements/:projectId/:viewSelector", element: <AgreementsTools /> },
  { path: "agreements/:sourceId", element: <AgreementWidget /> }, //sourceId is leadId or projectId
  { path: "edit/:documentId", element: <DocEdit /> }, //special widget that opens any document in word for editing
  { path: "transfer-letter/:leadId", element: <TransferLetterGenerator /> },
  { path: "demand/:projectId", element: <DemandDocGen /> },
];

export default docgenRoutes;
